/* InVogue (11 Oct 2026, Morgan): size searches. Shopify search treats "1200mm" as one word, so a search
   for "1200" found no products. Bare sizes are rewritten to the stored form before searching:
   "1200" -> "1200mm", "900x700" / "900 x 700" -> "900mm 700mm", "1200 mm" -> "1200mm".
   Product codes (anything with a letter-hyphen, e.g. MI-MC-0-7570, JD-WB703-2) are left alone. */
(function () {
  /* Tapware words (Morgan, 11 Oct 2026): shoppers say "gold tap", "faucet", "gun metal"; the catalogue says
     "Brushed Brass", "Mixer", "Gunmetal". Rewritten only when the search isn't about mirrors or cabinets
     (framed mirrors have a Gold option). */
  function tapWords(q) {
    if (typeof q !== 'string' || /mirror|cabinet|frame|led|vanity/i.test(q)) return q;
    var t = q.replace(/\bgold(en)?\b/gi, 'brushed brass')
      .replace(/\bgun\s*metal\b/gi, 'gunmetal')
      .replace(/\b(taps?|faucets?|tapware)\b/gi, function (m, w, off, all) { return all.trim().split(/\s+/).length > 1 ? (/tapware/i.test(m) ? '' : 'mixer') : m; });
    return t.replace(/\s+/g, ' ').trim() || q;
  }
  window.invTapWords = tapWords;
  /* Mirror searches (Morgan, 11 Oct 2026): "led mirror" used to return 59 taps (their copy mentions mirrors) and
     "cabinet" returned door hinges. Mirror-intent searches are scoped to mirror product types with Shopify's
     product_type: syntax; the shopper never sees it (it's stripped from the search box and headings). */
  var TAPISH = /\b(taps?|tapware|mixers?|faucets?|spouts?|showers?|wastes?|traps?|hinges?|handles?|doors?|locks?|towel|robe|hooks?|rails?|holders?|clamps?|kitchen|diverters?)\b/i;
  function mirrorScope(q) {
    if (typeof q !== 'string' || /product_type:/i.test(q) || TAPISH.test(q)) return q;
    if (/\b(cabinets?|shaving|medicine cabinet|shave)\b/i.test(q)) return q + ' product_type:"Mirror Cabinet"';
    if (/\b(mirrors?|led|smart|backlit|front.?lit|demister|anti.?fog|bluetooth)\b/i.test(q)) return q + ' product_type:Mirror*';
    return q;
  }
  function stripScope(q) { return typeof q === 'string' ? q.replace(/\s*product_type:("[^"]*"|\S+)/gi, '').trim() : q; }
  window.invStripScope = stripScope;
  function norm(q) { return mirrorScope(sizeNorm(tapWords(q))); }
  function sizeNorm(q) {
    if (typeof q !== 'string' || !/\d{3,4}/.test(q) || /[a-z]-|-[a-z0-9]/i.test(q)) return q;
    var t = q.replace(/(\d{3,4})\s*mm\b/gi, '$1mm');
    t = t.replace(/(\d{3,4})(?:mm)?\s*[x×*]\s*(\d{3,4})(?:mm)?/gi, '$1mm $2mm');
    t = t.replace(/\b(\d{3,4})(?![\d]|mm)/g, '$1mm');
    return t.replace(/\s+/g, ' ').trim();
  }
  window.invNormSize = norm;
  // Search suggestions (header overlay and search page) go through fetch.
  if (window.fetch && !window.__invSearchFetch) {
    window.__invSearchFetch = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/search/suggest') !== -1) {
          var u = new URL(url, location.origin), q = u.searchParams.get('q'), n = norm(q || '');
          if (q && n !== q) {
            u.searchParams.set('q', n);
            input = typeof input === 'string' ? u.pathname + u.search : new Request(u.toString(), input);
          }
        }
      } catch (e) {}
      return orig.call(this, input, init);
    };
  }
  // Full results: rewrite on submit, and on arrival at /search with a bare size (e.g. a shared link).
  document.addEventListener('submit', function (e) {
    var f = e.target, i = f && f.querySelector && f.querySelector('input[name="q"]');
    if (!i || !/\/search/.test(f.getAttribute('action') || '')) return;
    var n = norm(i.value); if (n !== i.value) i.value = n;
  }, true);
  if (/\/search\/?$/.test(location.pathname)) {
    var p = new URLSearchParams(location.search), q0 = p.get('q');
    if (q0 && norm(q0) !== q0) { p.set('q', norm(q0)); location.replace(location.pathname + '?' + p.toString()); }
    else if (q0 && /product_type:/i.test(q0)) {
      // show the shopper's own words, not the scoping syntax
      var clean = function () {
        document.querySelectorAll('input[name="q"]').forEach(function (i) { if (/product_type:/i.test(i.value)) i.value = stripScope(i.value); });
        var w = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { if (/product_type:/i.test(n.nodeValue)) n.nodeValue = stripScope(n.nodeValue); }
        document.title = stripScope(document.title);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean); else clean();
    }
  }
})();

/*
 * InVogue CRO (Oct 2026). Small, dependency-free helpers loaded on every page.
 *
 * 1. Sticky purchase bar (all PDPs; phone bottom bar + slim desktop bar, 12 Oct 2026). The bar is a mirror of the MAIN product form:
 *    - it never holds a variant id; "Add to cart" clicks the main form's own submit
 *      button, so the variant added is always the one shown in the main form;
 *    - price, label and disabled state are copied from the main form whenever they
 *      change (MutationObserver), so sold-out / pre-order / sale states stay in sync;
 *    - on multi-variant products opened without ?variant=, the bar asks the shopper to
 *      choose (state A) and scrolls to the selector instead of buying a default size.
 * 2. Gorgias launcher: body classes so CSS can lift it above the sticky bar and hide
 *    it while the cart drawer is open (no Gorgias settings are changed).
 */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 749px)');

  // "900mm (W) x 700mm (H) x 117mm (D)" -> "900 × 700 × 117 mm"; anything else unchanged.
  function formatOption(value) {
    var m = String(value).match(/^\s*(\d+)\s*mm\s*\(W\)\s*x\s*(\d+)\s*mm\s*\(?H\)?(?:\s*x\s*(\d+)\s*mm\s*\(D\))?\s*$/i);
    if (!m) return String(value).trim();
    return m[1] + ' × ' + m[2] + (m[3] ? ' × ' + m[3] : '') + ' mm';
  }

  function initSticky(bar) {
    var sectionId = bar.dataset.section;
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var mainForm = document.getElementById('product-form-' + sectionId);
    var priceSrc = document.getElementById('price-' + sectionId);
    var btn = bar.querySelector('[data-inv-sticky-btn]');
    var label = bar.querySelector('[data-inv-sticky-label]');
    var title = bar.querySelector('[data-inv-sticky-title]');
    var price = bar.querySelector('[data-inv-sticky-price]');
    if (!mainBtn || !mainForm || !btn) return;

    // Keep the bar outside transformed ancestors so position:fixed is viewport-relative.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    var needsChoice = bar.dataset.needsChoice === 'true';
    function findSelector() {
      return document.querySelector('#MainProduct-' + sectionId + ' variant-selects') ||
        document.querySelector('variant-selects');
    }
    var selector = findSelector();
    // The theme can re-render the picker on a variant change; always read the one on the page.
    function liveSelector() {
      if (selector && !selector.isConnected) selector = findSelector();
      return selector;
    }

    function visibleFieldsets() {
      if (!liveSelector()) return [];
      return Array.prototype.filter.call(selector.querySelectorAll('fieldset'), function (fs) {
        return fs.style.display !== 'none';
      });
    }
    // "Choose size" uses the first option the shopper can actually see.
    var firstFs = visibleFieldsets()[0];
    var firstLegend = firstFs && firstFs.querySelector('legend');
    if (firstLegend) {
      var optName = (firstLegend.childNodes[0] ? firstLegend.childNodes[0].textContent : firstLegend.textContent).replace(/[:\s]+$/, '').trim();
      if (optName) btn.dataset.chooseLabel = 'Choose ' + optName.toLowerCase();
    }
    if (!firstFs) needsChoice = false;

    function variantLabelFromSelector() {
      if (!liveSelector()) return '';
      var parts = [];
      visibleFieldsets().forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var sel = fs.querySelector('select');
        if (checked) parts.push(checked.value);
        else if (sel) parts.push(sel.value);
      });
      return parts.join(' · ');
    }

    // No buyable variant for the chosen options (Dawn empties the form's id input): ask to choose.
    function unavailable() {
      var idEl = mainForm.querySelector('[name="id"]');
      return !!firstFs && (!idEl || !idEl.value || idEl.disabled);
    }

    function sync() {
      if (needsChoice || unavailable()) {
        label.textContent = btn.dataset.chooseLabel || 'Choose size';
        btn.disabled = false;
        bar.classList.add('is-choose');
        return;
      }
      bar.classList.remove('is-choose');
      var mainLabel = mainBtn.querySelector('span');
      label.textContent = (mainLabel ? mainLabel.textContent : mainBtn.textContent).trim();
      btn.disabled = mainBtn.hasAttribute('disabled') || mainBtn.getAttribute('aria-disabled') === 'true';
      bar.classList.toggle('is-loading', mainBtn.classList.contains('loading'));
      if (priceSrc && price) {
        var current = priceSrc.querySelector('.price__sale .price-item--sale');
        var onSale = priceSrc.querySelector('.price--on-sale');
        var regular = priceSrc.querySelector('.price__regular .price-item--regular');
        var compare = priceSrc.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular');
        var text = onSale && current ? current.textContent.trim() : regular ? regular.textContent.trim() : '';
        if (text) {
          price.innerHTML = '';
          price.appendChild(document.createTextNode(text.replace(/\s*(AUD|NZD)\s*$/, '')));
          if (onSale && compare) {
            var s = document.createElement('s');
            s.textContent = compare.textContent.trim().replace(/\s*(AUD|NZD)\s*$/, '');
            price.appendChild(document.createTextNode(' '));
            price.appendChild(s);
          }
        }
      }
      var v = bar.dataset.single === 'true' ? '' : variantLabelFromSelector();
      if (title) {
        title.textContent = v ? formatOption(v.split(' · ')[0]) : '';
        var sep = bar.querySelector('.inv-sticky__sep');
        if (sep) sep.hidden = !title.textContent;
      }
    }

    // Any explicit interaction with the selector counts as a choice.
    if (selector) {
      selector.addEventListener('change', function () {
        needsChoice = false;
        // price/label update after product-info re-renders; sync again shortly after.
        setTimeout(sync, 50);
      });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.sectionId && event.data.sectionId !== sectionId) return;
        needsChoice = false;
        sync();
      });
    }
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceSrc) new MutationObserver(sync).observe(priceSrc, { childList: true, subtree: true, characterData: true });

    btn.addEventListener('click', function () {
      if ((needsChoice || unavailable()) && selector) {
        var target = visibleFieldsets()[0] || liveSelector();
        var top = target.getBoundingClientRect().top + window.scrollY - 120;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        target.classList.remove('inv-attention');
        void target.offsetWidth;
        target.classList.add('inv-attention');
        var first = target.querySelector('input:not([disabled]), select');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 450);
        return;
      }
      if (btn.disabled) return;
      mainBtn.click();
    });

    // 12 Oct 2026: phones AND desktop. Shows once the main Add to cart has scrolled above the
    // viewport; hides when it is back on screen, near the footer, or while a drawer/modal is open.
    var mainAbove = false;
    var nearFooter = false;
    // 13 Oct 2026 (Morgan, Koala layouts): data-mode="load" (mirror/cabinet pages) shows the bar from page load
    // and hides it only while the main Add to cart is on screen. Other pages keep "after it scrolls above".
    var fromLoad = bar.dataset.mode === 'load';
    var mainOff = false;
    function update() {
      var cls = document.body.classList;
      // Cart drawer / theme modals (overflow-hidden) and the Klaviyo pop-up both lock scrolling.
      var drawerOpen = cls.contains('overflow-hidden') || cls.contains('klaviyo-prevent-body-scrolling');
      var show = (fromLoad ? mainOff : mainAbove) && !nearFooter && !drawerOpen;
      if (bar.classList.contains('is-visible') === show) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('inv-sticky-on', show);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        mainAbove = !e.isIntersecting && e.boundingClientRect.top < 0;
        mainOff = !e.isIntersecting;
      });
      update();
    }, { threshold: 0 }).observe(mainBtn);
    // An instant jump (reload mid-page, anchor link, reduced-motion scroll) can carry the button from
    // below the screen to above it without ever intersecting, so the observer never fires. Re-check
    // the button's position on scroll as well (one read per frame).
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        var r = mainBtn.getBoundingClientRect();
        var above = r.bottom < 0;
        var off = above || r.top > window.innerHeight;
        if (above !== mainAbove || off !== mainOff) { mainAbove = above; mainOff = off; update(); }
      });
    }, { passive: true });
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { nearFooter = e.isIntersecting; });
        update();
      }, { rootMargin: '0px 0px 80px 0px', threshold: 0 }).observe(footer);
    }
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    sync();
  }

  /*
   * 3. Collection filters (P1-06). On mobile the sidebar's filter groups all started
   *    open, pushing the first product ~1,000px down. Groups now start collapsed on
   *    mobile unless they hold an active filter; desktop is unchanged. Re-applied after
   *    the facets section re-renders.
   */
  function collapseFilterGroups(root) {
    if (!MOBILE.matches) return;
    (root || document).querySelectorAll('.cs details.cs__group').forEach(function (d) {
      if (d.dataset.invTouched) return;
      if (!d.querySelector('input:checked')) d.removeAttribute('open');
      d.addEventListener('toggle', function () { d.dataset.invTouched = '1'; }, { once: true });
    });
  }

  /*
   * Grouped Size filter (mirror/cabinet collections, snippets/inv-size-filter.liquid).
   * A visible toggle stands for several raw size values; ticking it ticks every hidden member
   * checkbox (the inputs that carry filter.v.option.size), so facets.js sends all of them.
   * facets.js listens for 'input' with an 800 ms debounce, so updating members on 'change'
   * always lands before the request is built. Pills in the toolbar untick their group.
   * Delegated listeners, bound once - they survive facets.js re-rendering the sidebar.
   */
  function syncGroup(toggle) {
    (toggle.getAttribute('data-inv-sg-members') || '').split(',').forEach(function (id) {
      var m = id && document.getElementById(id);
      if (m) m.checked = toggle.checked;
    });
  }
  function initSizeGroups() {
    if (initSizeGroups.done) return;
    initSizeGroups.done = true;
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('inv-sg__toggle')) syncGroup(e.target);
    });
    document.addEventListener('click', function (e) {
      var pill = e.target.closest && e.target.closest('.inv-sg-remove');
      if (!pill) return;
      e.preventDefault();
      var t = document.getElementById(pill.getAttribute('data-inv-sg-target'));
      if (!t) return;
      t.checked = false;
      syncGroup(t);
      t.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function initFilters() {
    var cs = document.querySelector('.cs');
    if (!cs) return;
    collapseFilterGroups(cs);
    new MutationObserver(function () { collapseFilterGroups(cs); }).observe(cs, { childList: true, subtree: true });
  }

  /*
   * 4. Product-page star rating -> reviews (Oct 2026, Morgan). The Loox stars under the
   *    product title did nothing when tapped. They now scroll to this product's Loox
   *    reviews widget (#looxReviews) further down the page. Keyboard accessible.
   */
  function initReviewJump() {
    var target = document.getElementById('looxReviews');
    if (!target) return;
    document.querySelectorAll('.product__header-reviews').forEach(function (el) {
      var stars = el.querySelector('.loox-rating');
      var count = stars && stars.getAttribute('data-raters');
      el.classList.add('inv-review-jump');
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', (count ? count + ' reviews. ' : '') + 'Read customer reviews');
      // Lazy images and app widgets above the reviews keep growing while the page
      // scrolls, so the first scroll falls short. Re-aim until the reviews settle
      // under the header (or ~2.5s pass).
      function go(e) {
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var offset = 90;
        var tries = 0;
        function aim(behavior) {
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: behavior });
        }
        aim(reduce ? 'auto' : 'smooth');
        (function check() {
          tries += 1;
          setTimeout(function () {
            var delta = target.getBoundingClientRect().top - offset;
            if (Math.abs(delta) > 24 && tries < 10) {
              aim(tries < 3 && !reduce ? 'smooth' : 'auto');
              check();
            }
          }, 350);
        })();
      }
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') go(e);
      });
    });
  }

  /*
   * 5. Mirror & cabinet PDPs (.inv-pdp) - Oct 2026. Does nothing on any other page,
   *    including tapware PDPs.
   *    a) Keep the instalment line (#InvInstal-) and availability line (#InvStock-) in step
   *       with the selected variant, using the section HTML Dawn already fetched.
   *    b) Long introductions: collapse to 4 lines on mobile with a "Read more" toggle.
   *    c) Chat launcher: moved to initChatYield (5c), which also runs on tapware.
   */
  function initPdp() {
    var root = document.querySelector('.inv-pdp');
    if (!root) return;
    var sectionId = root.getAttribute('data-section');

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.html || data.sectionId !== sectionId) return;
        ['InvInstal-', 'InvStock-', 'InvGlance-'].forEach(function (prefix) {
          var fresh = data.html.getElementById(prefix + sectionId);
          var current = document.getElementById(prefix + sectionId);
          if (fresh && current) {
            current.className = fresh.className;
            current.innerHTML = fresh.innerHTML;
          }
        });
      });
    }

    var intro = root.querySelector('.product__short-description');
    var introLines = intro ? intro.getBoundingClientRect().height / (parseFloat(getComputedStyle(intro).lineHeight) || 24) : 0;
    if (intro && MOBILE.matches && introLines > 4.5) {
      intro.classList.add('inv-clamped');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'inv-pdp__more';
      more.textContent = 'Read more';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        var open = intro.classList.toggle('is-open');
        more.textContent = open ? 'Show less' : 'Read more';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      intro.insertAdjacentElement('afterend', more);
    }

  }

  /*
   * Cart page sticky checkout bar (Morgan, 13 Oct 2026). Phones only (CSS shows it under 750px).
   * Shows the estimated total and a Secure checkout button whenever the page's own checkout button
   * is off screen; the button clicks that real button (same form, same checkout). Re-reads the total
   * after the theme re-renders the cart (quantity change / remove) and hides on an empty cart.
   */
  function initCartSticky() {
    if (!document.body.classList.contains('template-cart')) return;
    var footer = document.getElementById('main-cart-footer');
    if (!footer || document.querySelector('.inv-cart-sticky')) return;
    var label = footer.querySelector('.totals__total');
    var bar = document.createElement('div');
    bar.className = 'inv-cart-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="inv-cart-sticky__total"><span class="inv-cart-sticky__label"></span>' +
      '<span class="inv-cart-sticky__value"></span></div>' +
      '<button type="button" class="inv-cart-sticky__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var lab = bar.querySelector('.inv-cart-sticky__label');
    var val = bar.querySelector('.inv-cart-sticky__value');
    var btn = bar.querySelector('.inv-cart-sticky__btn');
    function main() { return document.getElementById('checkout'); }
    function refresh() {
      var l = footer.querySelector('.totals__total');
      var v = footer.querySelector('.totals__total-value');
      lab.textContent = l ? l.textContent.trim() : '';
      val.textContent = v ? v.textContent.trim() : '';
      var m = main();
      if (m) btn.innerHTML = m.innerHTML;
    }
    var offscreen = false;
    function update() {
      var m = main();
      var empty = footer.classList.contains('is-empty') || !m || m.disabled;
      var show = offscreen && !empty && window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('inv-cart-sticky-on', show);
    }
    function check() {
      var m = main();
      if (!m) { offscreen = false; update(); return; }
      var r = m.getBoundingClientRect();
      offscreen = r.bottom < 0 || r.top > window.innerHeight - 10;
      update();
    }
    btn.addEventListener('click', function () { var m = main(); if (m && !m.disabled) m.click(); });
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; check(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    new MutationObserver(function () { refresh(); check(); }).observe(footer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    var items = document.querySelector('cart-items');
    if (items) new MutationObserver(onScroll).observe(items, { childList: true, subtree: true });
    refresh();
    check();
  }

  /*
   * 5c. Chat launcher on product pages (mirrors, cabinets AND tapware since 14 Oct 2026, Morgan D+E): it steps aside
   *     (body.inv-chat-yield) while it would sit on top of the title, stars, a purchase control, price, stock/delivery
   *     notice, accordion or review link. The zone is the launcher's real position, so it is right when the sticky
   *     bar has lifted it (body.inv-sticky-on), and it is re-checked when the bar shows/hides or the launcher loads.
   */
  function initChatYield() {
    if (!document.querySelector('.product__info-container')) return;
    var guarded = '.product__title > h1, .product__price-and-rating, .inv-pdp-instal, .inv-paylater, .payment-methods-box, variant-selects, .inv-ft, .inv-pdp-stock, ' +
      '.pm-pickup:not([hidden]), .product__buy-buttons-wrapper, .inv-qty, .pm-cta-buttons, .product__accordion summary, .inv-review-jump, .inv-pdp__more, .inv-sticky.is-visible .inv-sticky__btn';
    var ticking = false;
    function zone() {
      var vw = window.innerWidth, vh = window.innerHeight;
      var cb = document.querySelector('#gorgias-chat-container #chat-button');
      var r = cb && cb.getBoundingClientRect();
      // the launcher is clipped by CSS to a 25px circle centred 38px in / 27px down
      if (r && r.height) return { left: r.left + 13, right: Math.min(r.left + 63, vw), top: r.top + 2, bottom: r.top + 52 };
      var lift = document.body.classList.contains('inv-sticky-on') ? 92 : 0;
      return { left: vw - 76, right: vw, top: vh - 84 - lift, bottom: vh - lift };
    }
    function chatCheck() {
      ticking = false;
      if (!MOBILE.matches) { document.body.classList.remove('inv-chat-yield'); return; }
      var z = zone();
      var hit = Array.prototype.some.call(document.querySelectorAll(guarded), function (el) {
        var r = el.getBoundingClientRect();
        return r.width && r.height && r.left < z.right && r.right > z.left && r.top < z.bottom && r.bottom > z.top;
      });
      if (document.body.classList.contains('inv-chat-yield') !== hit) document.body.classList.toggle('inv-chat-yield', hit);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(chatCheck); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // sticky bar toggles body.inv-sticky-on (moves the launcher); Gorgias inserts its launcher late
    new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(onScroll).observe(document.body, { childList: true });
    [350, 1500, 3500, 7000].forEach(function (t) { setTimeout(onScroll, t); }); // lift transition; Gorgias loads late
    chatCheck();
  }

  function run() {
    initCartSticky();
    document.querySelectorAll('[data-inv-sticky]').forEach(initSticky);
    initSizeGroups();
    initFilters();
    initReviewJump();
    initPdp();
    initChatYield();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Mobile collection filter sheet (Morgan, 11 Oct 2026). The existing filter panel (aside.cs) is reused as-is,
   so filtering keeps working exactly as before; on phones it opens as a bottom sheet from a "Filter" button. */
(function () {
  function init() {
    var tb = document.querySelector('.cp__toolbar'), aside = document.querySelector('.cp__layout aside.cs');
    if (!tb || !aside || tb.querySelector('.inv-cf-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'inv-cf-btn'; btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg><span>Filter</span>';
    tb.insertBefore(btn, tb.querySelector('.cp__sort'));
    var bd = document.createElement('div'); bd.className = 'inv-cf-backdrop'; document.body.appendChild(bd);
    function head() {
      if (aside.querySelector('.inv-cf-head')) return;
      var h = document.createElement('div'); h.className = 'inv-cf-head';
      h.innerHTML = '<span>Filter</span><button type="button" class="inv-cf-done">Show results</button>';
      aside.insertBefore(h, aside.firstChild);
    }
    function count() {
      /* Count what the shopper ticked: grouped size toggles count once each; their hidden member inputs are skipped. */
      var n = aside.querySelectorAll('.inv-sg__toggle:checked').length;
      aside.querySelectorAll('.js-filter input:checked').forEach(function (i) {
        if (i.classList.contains('inv-sg__toggle') || i.closest('.inv-sg') || /^cs-size/.test(i.id || '')) return;
        n++;
      });
      btn.querySelector('span').textContent = n ? 'Filter (' + n + ')' : 'Filter';
    }
    function open() { head(); aside.querySelectorAll('details.js-filter').forEach(function (d) { d.open = true; }); document.body.classList.add('inv-cf-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { document.body.classList.remove('inv-cf-open'); btn.setAttribute('aria-expanded', 'false'); count(); }
    btn.addEventListener('click', open);
    bd.addEventListener('click', close);
    aside.addEventListener('click', function (e) { if (e.target.closest('.inv-cf-done')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (window.MutationObserver) new MutationObserver(function () { count(); if (document.body.classList.contains('inv-cf-open')) head(); }).observe(aside, { childList: true, subtree: true });
    count();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
